import React, { useState } from 'react';
import { Mail, ArrowLeft } from 'lucide-react';
import { dynastyTheme } from '../../../services/colorService';
import { mobilePageBackground } from '../../../services/mobileStyleService';
import { getBaseballBackground } from './baseballAssets';

const MobileResetPasswordStep1 = ({ onSendCode, onBack, loading, error, message }) => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSendCode(email);
  };

  return (
    <div 
      className="min-h-screen flex flex-col"
      style={{ background: mobilePageBackground, ...getBaseballBackground() }}
    >
      {/* Header */}
      <div className={`flex items-center justify-between px-6 py-4 border-b ${dynastyTheme.classes.border.neutral}`}>
        <button
          onClick={onBack}
          className={`flex items-center gap-2 ${dynastyTheme.classes.text.neutralLighter} hover:${dynastyTheme.classes.text.white} ${dynastyTheme.classes.transition}`}
        >
          <ArrowLeft className="w-5 h-5" />
          Back
        </button>
        <h2 className={`text-lg font-semibold ${dynastyTheme.classes.text.white}`}>
          Forgot Password
        </h2>
        <div className="w-16"></div> {/* Spacer for centering */}
      </div>

      {/* Content */}
      <div className="flex-1 px-6 py-8 flex flex-col justify-center">
        <form onSubmit={handleSubmit} className="space-y-6 max-w-md mx-auto w-full">
          {/* Icon */}
          <div className="text-center mb-8">
            <div className="text-6xl mb-4">🔑</div>
            <h3 className={`text-xl font-bold ${dynastyTheme.classes.text.white} mb-3`}>
              Reset Your Password
            </h3>
            <p className={`text-sm ${dynastyTheme.classes.text.neutralLighter}`}>
              Enter your email and we'll send you a code to reset your password
            </p>
          </div>

          {/* Success Message */}
          {message && (
            <div className={`${dynastyTheme.components.badge.info} p-4 rounded-lg text-center`}>
              {message}
            </div>
          )}

          {/* Error Message */}
          {error && (
            <div className={`${dynastyTheme.components.badge.error} p-4 rounded-lg text-center`}>
              {error}
            </div>
          )}

          {/* Email Input */}
          <div>
            <label className={dynastyTheme.components.label}>
              Email
            </label>
            <div className="relative">
              <Mail className={`absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 ${dynastyTheme.classes.text.neutralLighter}`} />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`${dynastyTheme.components.input} w-full pl-12 pr-4 py-3 text-base`}
                placeholder="your@email.com"
                required
                autoComplete="email"
              />
            </div>
          </div>

          {/* Send Code Button */}
          <button
            type="submit"
            disabled={loading || !email}
            className={`${dynastyTheme.utils.getComponent('button', 'primary', 'lg')} w-full flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            {loading ? (
              <>Sending...</>
            ) : (
              <>
                <span>📧</span>
                Send Reset Code
              </>
            )}
          </button>

          {/* Back to Sign In */}
          <div className="text-center">
            <button
              type="button"
              onClick={onBack}
              className={`text-sm ${dynastyTheme.classes.text.neutralLighter} hover:${dynastyTheme.classes.text.primary} ${dynastyTheme.classes.transition}`}
            >
              Remember your password?{' '}
              <span className={dynastyTheme.classes.text.primary}>Back to Sign In</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MobileResetPasswordStep1;
